import { GQL_QUERIES } from 'src/utils/analytics/newrelic/ErrorTracker';

import generateFetchMusicQueryParams from './fetchMusicHandler';
import { FETCH_MUSIC_DATA_QUERY } from '../../GraphQL/Queries/MusicQuery';
import { graphQlRequest } from '../../GraphQL/RequestHandler';
import { ContentMetaData } from '../../responseTypes/movieResponse';

export const fetchMusic = async (
  movieId: string | undefined = '',
  country: string,
  translation: string,
  assetSubType: string
): Promise<ContentMetaData | any> => {
  try {
    const response: any = await graphQlRequest(
      FETCH_MUSIC_DATA_QUERY,
      generateFetchMusicQueryParams(
        movieId,
        country,
        translation,
        assetSubType
      ),
      GQL_QUERIES.FETCH_MUSIC_DATA_QUERY
    );

    return response?.movies?.contents || [];
  } catch (error) {
    console.error('Error while fetching latest movies: ', error);
    return {};
  }
};
